import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

import { ContentStatus } from "./knowledgeDb";

const { REQUIRED } = ERROR_TYPE;

export interface CaseStudy {
	id: number;
	clientName: string;
	website: string;
	matchedSegment: string;
	description: string;
	industry: string[];
	employeeCount: number;
	enrichmentSource: string;
	projectName: string;
	goalsChallenge: string;
	solution: string;
	outcome: string;
	quote: string;
	quoteAttribution: string;
	sourceUrl: string;
	detectedDate: string;
	status: ContentStatus;
	companyId: number;
	createdAt: string;
	updatedAt: string;
}

export interface AutoUpdateSettings {
	id: number;
	autoUpdateEnabled: boolean;
	caseStudyUrl: string;
	caseStudyDocumentUrl: string;
	lastAutoUpdate: string | null;
	autoUpdateInProgress: boolean;
	userId: number;
	companyId: number;
	createdAt: string;
	updatedAt: string;
}

export const CreateCaseStudySchema = z.object({
	clientName: z.string().min(1, { message: REQUIRED }).trim(),
	website: z.string().trim().optional().or(z.literal("")),
	goalsChallenge: z.string().min(1, { message: REQUIRED }).trim(),
	solution: z.string().min(1, { message: REQUIRED }).trim(),
	outcome: z.string().min(1, { message: REQUIRED }).trim(),
	quoteText: z.string().trim().optional().or(z.literal("")),
	quoteAttribution: z.string().trim().optional().or(z.literal("")),
	autoEnrich: z.boolean().optional(),
});

export type CreateCaseStudy = z.infer<typeof CreateCaseStudySchema>;
